import axios from "axios";
export const GetThemeDetails = {
  data: () => ({}),
  mounted() {},
  methods: {
    async GetThemeDetailsMethod(theme_path) {
      try {
        var data = {
          theme_path,
        };
        var config = {
          method: "post",
          maxBodyLength: Infinity,
          url: process.env.VUE_APP_AWS_THEME_DETAILS_REST_API_URL,
          headers: {
            "x-api-key": process.env.VUE_APP_AWS_THEME_REST_API_X_API_KEY,
          },
          data: data,
        };
        let result = await axios(config);
        // console.log("result of GetThemeDetailsMethod",result)
        return result;
      } catch (error) {
        return {
          status: error?.response?.status || error,
          statusText: "FAILURE",
          error: error?.response?.data?.Model || error,
        };
      }
    },
  },
};
